import Cookies from "js-cookie";

const TOKEN_KEY = "_mc_token";

export function setToken(token, option) {
  return Cookies.set(TOKEN_KEY, token, option);
}

export function getToken() {
  return Cookies.get(TOKEN_KEY);
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY);
}

/**
 * set localStorage
 * @param {string} key
 * @param {object} data
 */
export function setLocalItem(key, data) {
  return localStorage.setItem(key, JSON.stringify(data));
}

/**
 * get localStorage
 * @param {string} key
 */
export function getLocalItem(key) {
  const value = localStorage.getItem(key);
  return value && value != "undefined" ? JSON.parse(value) : undefined;
}

/**
 * clear single localStorage
 * @param {string} key
 */
export function removeLocalItem(key) {
  return localStorage.removeItem(key);
}

/**
 * clear all localStorage
 */
export function clearLocalItem() {
  return localStorage.clear();
}
